export const Allowed_Routes = {
    Receptionist: ['Receptionist'],
    Coordinator: ['Coordinator'],
}

export const Allowed_Paths = {
    Hospital: 'all',
    Receptionist: ['/receptionist', '/patients'],
    Coordinator: ['/coordinator'],
}

export const SERVER = "https://api.bookurappointment.com"